export const MODAL_ID = 'notifications-bucket-modal';
